<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="!!data">
    <InputTextArea
        v-model="data"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";

import QuestionBase from "../../../QuestionBase";
import InputTextArea from "../../../inputs/InputTextArea";

export default {
  name: 'CCJDetails',
  mixins: [questionLoadHelpers],
  components: {
    InputTextArea,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'Please add a few details about any CCJ\'s / Default\'s',
        subTitle:  'When was this registered? For what amount? When was it satisfied or is it still outstanding?',
        tip: null
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'profileCCJDetails'
      },
      args: {
        placeholder: '',
        label: null,
        rows: 4,
        maxRows: 4,
        skippable: false,
        required: false,
        inputClass: 'field-100'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>